<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text> Are you sure you want to delete this bucket type ?</v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          class="mx-0 font-weight-light"
          color="success"          
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    props: {
      fundBucketHasType: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true
        this.$api.fundBucketHasTypes().delete(this.fundBucketHasType.id)
          .then(response => {
            if (response.status === 200) {
              this.$emit('deleted')
              this.$snack({ color: 'success', message: response.data.message })
            }
          })
          .catch(err => {
            this.$snack({ color: 'error', message: err.response.statusText })
          })
          .then(() => {
            this.menu = false
            this.progressing = false
          })    
      },
    },
  }
</script>
